import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import { Calendar, CalendarProps, momentLocalizer, View, Views } from 'react-big-calendar'
import React from 'react'
import Toolbar from './Toolbar'
import moment from 'moment'
import { ICalendarEvent } from '../../../types'
import { CalendarColorsMap } from '../../../config/data'
const DnDCalendar = withDragAndDrop(Calendar as React.ComponentType<CalendarProps<any, object>>)
const localizer = momentLocalizer(moment)
moment.locale('ko', {
  week: {
    dow: 0,
    doy: 1,
  },
})

const getEventStyle = (
  event: ICalendarEvent
): {
  style: any
} => {
  let style: any = {
    minWidth: '50px',
    minHeight: '25px !important',
    borderRadius: '5px',
    padding: '5px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '17px',
    role: 'calendar-event',
  }
  const hasEventPassed = moment(event.startDateTime).isBefore(moment())
  style = {
    ...style,
    backgroundColor: CalendarColorsMap.get(event.eventType),
    color: '#0085ff',
    opacity: hasEventPassed ? 0.5 : 1,
  }

  if (event.meeting === 'review') {
    style = { ...style, backgroundColor: '#7B61FF2B', color: '#7B61FF' }
  }
  if (event.meeting === 'playbook') {
    style = { ...style, backgroundColor: '#F4F4F5', color: '#52525B' }
  }
  return {
    style: style,
  }
}

export interface CalendarViewerProps {
  onSelectEvent: (calEvent: ICalendarEvent) => void
  isMobile: boolean
  view: View
  setView: (value: React.SetStateAction<View>) => void
  setDate: (date: Date) => void
  date: Date
  calendarEvents: ICalendarEvent[]
}
export const CalendarViewer = ({
  onSelectEvent,
  isMobile,
  setView,
  setDate,
  view,
  date,
  calendarEvents,
}: CalendarViewerProps) => {
  return (
    <div data-testid="calendar-viewer">
      <DnDCalendar
        drilldownView="month"
        popup={true}
        localizer={localizer}
        events={calendarEvents}
        endAccessor="end"
        startAccessor="start"
        view={view}
        date={date}
        style={{ height: 'calc(100vh - 67px)', position: 'relative' }}
        step={60}
        eventPropGetter={getEventStyle}
        onSelectEvent={onSelectEvent}
        onDrillDown={(e) => {
          setDate(e)
          setView(Views.DAY)
        }}
        showMultiDayTimes
        components={{
          toolbar: (params) => <Toolbar setDate={setDate} setView={setView} {...params} />,
          event: EventTitle,
        }}
      />
    </div>
  )
}

const EventTitle = ({ event }) => (
  <>
    <span className="text-xs">
      {moment(event.startDateTime).format('h:mma')}
      <span className="font-semibold"> {event.title} </span>
    </span>
  </>
)
